import { ReactNode, useState } from "react";
import { useCopyToClipboard } from "usehooks-ts";

export const CopyContactAttrToClipboard: React.FC<{
  getAttr: () => string;
  title: string;
  icon: ReactNode;
  disabled?: boolean;
}> = ({ getAttr, title, icon, disabled }) => {
  const [, copyToClipboard] = useCopyToClipboard();
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const handleCopyToClipboard = async () => {
    const attrValue = getAttr();
    await copyToClipboard(attrValue);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <button
      className="w-6 flex-none text-center text-dm-brand-blue-500 hover:text-dm-brand-blue-800 disabled:cursor-not-allowed disabled:text-dm-gray-200"
      title={title}
      disabled={disabled}
      type="button"
      onClick={handleCopyToClipboard}
    >
      {isCopied ? <i className="fas fa-check" /> : icon}
    </button>
  );
};
